// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"b5e24b772e55c8e8","6831":"e0a220b8a4ba36bc","8503":"65de251272efe234","9683":"b86a61827c9c28bb"}[chunkId] + ".js";
};